import React , { useState , useEffect , useContext } from "react";
import { Link , NavLink , useNavigate  } from "react-router-dom";
import  { WebAssetsContext }  from "../App";
const  Commission = (props) => {

  const WebAssets = useContext(WebAssetsContext);
  const api = WebAssets.apiURL;
  const navigate = useNavigate();
  const [txns, setTxns] = useState([]);
    const fetchData = () => {
      fetch(api+"getcommissionTxn")
        .then(res => res.json())
        .then((result) => {
          console.log(result);
            if(result.status == true)
            {
              setTxns(result.response);
            }
          }
        )
      }
    useEffect(() => {
        fetchData();
    },[])
   

  return (
    <>
       <div className="section-body">
                  <div className="row">
                    <div className="col-12">
                        <div className="card">
                        <div className="pt-4 pl-4 pr-4">
                        <div className="card-header pl-0 pr-0 w-50 float-left">
                                    <h4 className="headercolor" >Commission List</h4>
                                </div>
                               
                                    </div>
                            <div className="card-body pl-4 pr-4 pb-4 pt-0">
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th className="text-center">S.NO</th>
                                                <th><div className="w-170">Customer ID</div></th>
                                                <th><div className="w-170">Customer Name</div></th>
                                                <th><div className="w-170">Transaction ID</div></th>
                                                <th><div className="w-170">Amount</div></th>
                                                <th><div className="w-170">Commission</div></th>
                                                <th><div className="w-170">Txn Amount</div></th>
                                                <th><div className="w-170">Date</div></th>
                                                <th className="text-right">Status</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                          {txns.length > 0 ? txns.map((txn , i)  => (
                                            <tr key={i}>
                                                <td className="text-center">{i + 1}</td>
                                                <td><span className="txnIDhighlighter">#{txn.user_id}</span></td>
                                                <td><span className="txnIDhighlighters">{txn.customer_name}</span></td>
                                                <td>{txn.txn_id}</td>
                                                
                                                <td><span className="txnIDhighlighters">{props.currencySymbol()}{txn.amount}</span></td>
                                                <td><span className="txnIDhighlighter">{props.currencySymbol()}{txn.commission}</span></td>

                                                <td><span className="txnIDhighlighters">{props.currencySymbol()}{txn.price}</span></td>
                                                
                                                <td>{props.changeDateFotmate(txn.created_date , 'DD-MM-YYYY h:m:s a')}</td>
                                                <td className="text-right">
                                                { txn.status == 'Complete' ? <div className="badge badge-success">Complete</div> : ''}  
                                                
                                                { txn.status == 'Pending' ? <div className="badge badge-danger">Pending</div> : ''}
                                                { txn.status == 'Cencel' ? <div className="badge badge-dark">Cencel</div> : ''}
                                                </td>
                                               
                                            </tr>
                                            ))  : 

                                            <tr><td colSpan="10" className="text-center">Data not yet found. </td></tr> 
                                           }
                                            
                                          </tbody>
                                    </table>
                                  </div>
                            </div>
                        </div>
                      </div>
                  </div>
                  </div>
    </>

  );
}

export default Commission;
